var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BaseAnimationBuilder = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _animation = require("../../animation");
var _commonTypes = require("../../commonTypes");
var _util = require("../../animation/util");
var _class;
var _worklet_13836389523485_init_data = {
    code: "function anonymous(delay,animation){const{withDelay,reduceMotion}=this.__closure;return withDelay(delay,animation,reduceMotion);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/animationBuilder/BaseAnimationBuilder.ts",
    sourceMap: '{"version":3,"names":["anonymous","delay","animation","withDelay","reduceMotion","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/animationBuilder/BaseAnimationBuilder.ts"],"mappings":"AAiHQ,QAAC,CAAAA,SAAOA,CAAAC,KAAA,CAAAC,SAAc,QAAAC,SAAA,CAAAC,YAAA,OAAAC,SAAA,CAEpB,MAAO,CAAAF,SAAS,CAACF,KAAK,CAAEC,SAAS,CAAEE,YAAY,CAAC,CAClD"}',
    version: "3.5.4"
};
var _worklet_5312609872546_init_data = {
    code: "function anonymous(_,animation){const{getReduceMotionFromConfig,reduceMotion}=this.__closure;animation.reduceMotion=getReduceMotionFromConfig(reduceMotion);return animation;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/animationBuilder/BaseAnimationBuilder.ts",
    sourceMap: '{"version":3,"names":["anonymous","_","animation","getReduceMotionFromConfig","reduceMotion","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/animationBuilder/BaseAnimationBuilder.ts"],"mappings":"AAqHQ,QAAC,CAAAA,SAAGA,CAAAC,CAAA,CAAAC,SAAc,QAAAC,yBAAA,CAAAC,YAAA,OAAAC,SAAA,CAEhBH,SAAS,CAACE,YAAY,CAAGD,yBAAyB,CAACC,YAAY,CAAC,CAChE,MAAO,CAAAF,SAAS,CAClB"}',
    version: "3.5.4"
};
var BaseAnimationBuilder = exports.BaseAnimationBuilder = function() {
    function BaseAnimationBuilder() {
        (0, _classCallCheck2.default)(this, BaseAnimationBuilder);
        this.durationV = void 0;
        this.delayV = void 0;
        this.reduceMotionV = _commonTypes.ReduceMotion.System;
        this.randomizeDelay = false;
        this.callbackV = void 0;
        this.build = function() {
            throw new Error("[Reanimated] Unimplemented method in child class.");
        };
    }
    (0, _createClass2.default)(BaseAnimationBuilder, [
        {
            key: "duration",
            value: function duration(durationMs) {
                this.durationV = durationMs;
                return this;
            }
        },
        {
            key: "delay",
            value: function delay(delayMs) {
                this.delayV = delayMs;
                return this;
            }
        },
        {
            key: "withCallback",
            value: function withCallback(callback) {
                this.callbackV = callback;
                return this;
            }
        },
        {
            key: "reduceMotion",
            value: function reduceMotion(reduceMotionV) {
                this.reduceMotionV = reduceMotionV;
                return this;
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                var _this$durationV;
                return (_this$durationV = this.durationV) != null ? _this$durationV : 300;
            }
        },
        {
            key: "randomDelay",
            value: function randomDelay() {
                this.randomizeDelay = true;
                return this;
            }
        },
        {
            key: "getDelay",
            value: function getDelay() {
                var _this$delayV, _this$delayV2;
                return this.randomizeDelay ? Math.random() * ((_this$delayV = this.delayV) != null ? _this$delayV : 1000) : (_this$delayV2 = this.delayV) != null ? _this$delayV2 : 0;
            }
        },
        {
            key: "getReduceMotion",
            value: function getReduceMotion() {
                return this.reduceMotionV;
            }
        },
        {
            key: "getDelayFunction",
            value: function getDelayFunction() {
                var isDelayProvided = this.randomizeDelay || this.delayV;
                var reduceMotion = this.getReduceMotion();
                return isDelayProvided ? function() {
                    var _e = [
                        new global.Error(),
                        -3,
                        -27
                    ];
                    var anonymous = function anonymous(delay, animation) {
                        return (0, _animation.withDelay)(delay, animation, reduceMotion);
                    };
                    anonymous.__closure = {
                        withDelay: _animation.withDelay,
                        reduceMotion: reduceMotion
                    };
                    anonymous.__initData = _worklet_13836389523485_init_data;
                    anonymous.__workletHash = 13836389523485;
                    anonymous.__stackDetails = _e;
                    return anonymous;
                }() : function() {
                    var _e = [
                        new global.Error(),
                        -3,
                        -27
                    ];
                    var anonymous = function anonymous(_, animation) {
                        animation.reduceMotion = (0, _util.getReduceMotionFromConfig)(reduceMotion);
                        return animation;
                    };
                    anonymous.__closure = {
                        getReduceMotionFromConfig: _util.getReduceMotionFromConfig,
                        reduceMotion: reduceMotion
                    };
                    anonymous.__initData = _worklet_5312609872546_init_data;
                    anonymous.__workletHash = 5312609872546;
                    anonymous.__stackDetails = _e;
                    return anonymous;
                }();
            }
        }
    ], [
        {
            key: "duration",
            value: function duration(durationMs) {
                var instance = this.createInstance();
                return instance.duration(durationMs);
            }
        },
        {
            key: "delay",
            value: function delay(delayMs) {
                var instance = this.createInstance();
                return instance.delay(delayMs);
            }
        },
        {
            key: "withCallback",
            value: function withCallback(callback) {
                var instance = this.createInstance();
                return instance.withCallback(callback);
            }
        },
        {
            key: "reduceMotion",
            value: function reduceMotion(reduceMotionV) {
                var instance = this.createInstance();
                return instance.reduceMotion(reduceMotionV);
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return 300;
            }
        },
        {
            key: "randomDelay",
            value: function randomDelay() {
                var instance = this.createInstance();
                return instance.randomDelay();
            }
        },
        {
            key: "build",
            value: function build() {
                var instance = this.createInstance();
                return instance.build();
            }
        }
    ]);
    return BaseAnimationBuilder;
}();
_class = BaseAnimationBuilder;
BaseAnimationBuilder.createInstance = void 0;
